<script setup lang="ts">
//
</script>

<template>
  <header class="flex gap-2 justify-between p-4">
    <slot></slot>
  </header>
</template>

<style scoped></style>
